import { CaseField } from '../../domain/definition';
import { Injectable } from '@angular/core';

@Injectable()
export class FieldTypeSanitiser {

  /**
   * This method finds dynamiclists in a form and replaces its string value, with
   * following example JSON format
   * @return {value: {code:'xyz',label:'XYZ'}, list_items: [{code:'xyz',label:'XYZ'},{code:'abc',label:'ABC'}]}
   * @param caseFields
   * @param editForm
   */
  sanitiseLists(caseFields: CaseField[], editForm: any) {

    this.getDynamicListsFromCaseFields(caseFields).forEach(dynamicField => {
      this.getListOfKeysFromEditForm(editForm).forEach((key) => {
        this.createValueCodePairAlongWithListIfKeyExistsInForm(dynamicField, key, editForm);
      });
    });
  }

  private createValueCodePairAlongWithListIfKeyExistsInForm(dynamicField: CaseField, key, editForm: any) {
    if (dynamicField.id === key) {
      editForm['data'][key] = {
        value: this.getMatchingCodeFromListOfItems(dynamicField, editForm, key),
        list_items: dynamicField.list_items
      };
    }
  }

  private getMatchingCodeFromListOfItems(dynamicField: CaseField, editForm: any, key) {
    const rawCode = typeof editForm['data'][key] === 'string' ? editForm['data'][key] : editForm['data'][key]?.code;
    let result = dynamicField.list_items.filter(value => String(value.code) === rawCode);
    if (result.length > 0) {
      result[0].code = String(result[0].code);
      return result[0];
    }
    return {};
  }

  private getListOfKeysFromEditForm(editForm: any) {
    return Object.keys(editForm['data']);
  }

  private getDynamicListsFromCaseFields(caseFields: CaseField[]): CaseField[] {
    return caseFields
      .filter(caseField => caseField.field_type.type === 'DynamicList');
  }
}
